import Vue from "vue";
import '@/libs/toastification'

export default Vue.$toast